import type { UseFormRegisterReturn } from "react-hook-form";

// The apply form has nine plain text fields with identical label/input/error
// markup. They live here so ApplyPage stays readable; the email, phone and file
// inputs keep their own markup on the page because each is decorated
// differently (icon wrapper, live mask, file input).
interface ApplyTextFieldProps {
    id: string;
    label: string;
    registration: UseFormRegisterReturn;
    error?: string;
}

export const ApplyTextField = ({
    id,
    label,
    registration,
    error,
}: ApplyTextFieldProps) => (
    <div>
        <label htmlFor={id} className="block font-bold mb-2">
            {label}
        </label>
        <input
            id={id}
            type="text"
            className="input input-bordered w-full bg-white text-neutral"
            {...registration}
        />
        {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
);
